import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ContactSubmissionTopicActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Web/ContactSubmissionTopic/ContactSubmissionTopicBrowser.js")
	}

	render() {
		return (
			<Activity 
				name="ContactSubmissionTopic"
				RenderedComponent={this.RenderedComponent}
				context="ContactSubmissionTopic"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ContactSubmissionTopicActivity)
